<template>
  <g class="spots">
    <template v-for="spot in spots">
      <visualization-pin
        v-if="isUnSelectedSpotPin(spot)"
        :key="spot.id"
        :spot="spot"
      />
    </template>

    <visualization-pin
      v-if="selectedSpotPin"
      :spot="selectedSpotPin"
    />
  </g>
</template>

<script>
import visualizationPin from './spot/base.vue';

export default {
  components: {
    visualizationPin,
  },
  data() {
    return {
      circleSize: 100,
    };
  },
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    destination: ({ $store }) => $store.state.searchResult.destination,
    selectedSpotPin() {
      const exist = Object.keys(this.destination).length > 0 && this.destination.type.indexOf('Spot') >= 0;
      if (!exist || this.spots.length === 0) return false;

      return this.spots.find((spot) => spot.id === this.destination.id);
    },
    isUnSelectedSpotPin() {
      return (spot) => !this.selectedSpotPin || spot.id !== this.destination.id;
    },
  },
  created() {
    this.$store.dispatch('area/getFloorSpots', this.currentFloorId);
  },
};
</script>



// WEBPACK FOOTER //
// spot.vue?3f673efc